module.exports = __webpack_public_path__ + "static/Sonyax4b-bfad0fa07abf642d3040f12b7a6b5239.png";